import React from 'react';
import { get, isEmpty, toInteger,isUndefined } from 'lodash';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

// local dependencies
import { reactivateEpost as ReactivateEpostView } from 'ui/views/widgets/reactivateEpost';
import { ReactivateEpostWidgetService } from 'services/reactivateEpostWidget';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { messageBus as MessageBus } from 'core/modules/message-bus';
import * as MESSAGE_BUS_EVENTS from 'constants/message-bus-events';
import { DASHBOARD_SUB_ROUTES } from 'constants/route-paths';
import { getAppSyncData } from 'utils/getAppSyncData';
import { createReactivationFlowId } from 'utils/createReactivationFlowId';
/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { ReactivateEpostWidget } from 'ui/containers/ReactivateEpostWidget';
 *
 * // render
 * <ReactivateEpostWidget propName='propValue'/>
 */
class _ReactivateEpostWidget extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // check if URL container `step` query parameter.
        const queryParams = queryString.parse( this.props.location.search );
		
		// const patientId = !isEmpty(this.props.location.state) && undefined!==this.props.location.state ?this.props.location.state.patientId:'';
		
		//Handled patientId with null check
		const patientId = !isEmpty(this.props.location.state) && undefined!==this.props.location.state && !isEmpty(this.props.location.state.patientId) && undefined!==this.props.location.state.patientId ?this.props.location.state.patientId:'';
        // component state
		this.state = {
			isFetching: true,
			networkStatus: undefined,
			componentData: undefined,
			isCallDispositionVisible: false,
			callReasonValidationState: false,
			patientId: patientId,
			currentStep: toInteger( get( queryParams, 'step', 1 ) ),
			successView: undefined
		};
      this.data = {
			reactivationFlowId: get( this.props.location, 'state.reactivationFlowId', undefined )
                || get( queryParams, 'reactivationFlowId', undefined ) || createReactivationFlowId(),
			memberId: isUndefined( this.props.location.state ) 
                ? getAppSyncData( 'memberId' )
                : get( this.props.location, 'state.memberId', undefined ),
			patientId: isUndefined( this.props.location.state )
                ? getAppSyncData( 'patientId' )
                : get( this.props.location, 'state.patientId', undefined )
		};
		if ( ! get( this.props.location, 'state.reactivationFlowId', undefined ) ) {
			this.props.history.replace( {
				pathname: this.props.location.pathname,
				search: this.props.location.search,
				hash: this.props.location.hash,
				state: { ...( this.props.location.state || {} ), reactivationFlowId: this.data.reactivationFlowId }
			} );
		}
		// create service instance
		this.reactivateEpostWidgetService = new ReactivateEpostWidgetService();

		// start component data fetch
		this.fetchComponentData();

		this.__bind();
	}
	
	__bind() {
        this.handleSuccessfullEnrollment = this.handleSuccessfullEnrollment.bind( this );
        this.onSuccessfulEnrollment = this.onSuccessfulEnrollment.bind( this );
        MessageBus.on( MESSAGE_BUS_EVENTS.SHOW_EPOST_JOURNEY_SUCCESS_VIEW, this.onSuccessfulEnrollment, this );
    }


	/*********************************************/

	/**
     * show the success view
     */
    onSuccessfulEnrollment( { data } ) {
        log.debug( 'ReactivateEpostWidget.onSuccessfulEnrollment()' );

        this.setState( { successView: data } );
	}
	
	/**
     * on successful enrollment
     */
    handleSuccessfullEnrollment() {
        log.debug( 'ReactivateEpostWidget.handleSuccessfullEnrollment()' );

		//const memberId = this.data.memberId;
		//const patientId = this.data.patientId;

		this.props.history.push( {
			pathname: DASHBOARD_SUB_ROUTES.MEMBER_MANAGEMENT,
			state: { memberId: this.data.memberId , patientId: this.data.patientId }
		} );
    }

	/**
	 * @desc Fetch component response.
	 */
	async fetchComponentData() {
		log.debug( 'ReactivateEpostWidget.fetchComponentData()' );

		// cancel ongoing request
		this.reactivateEpostWidgetService.cancel();

		// fetch component data
		const {
			status,
			data,
		} = await this.reactivateEpostWidgetService.fetchComponentData( {
			url: this.props.widget.url,
			data: {},
		} );

		// check if response status was success
		if ( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
			this.setState( {
				isFetching: false,
				networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
			} );
		} else {
			this.setState( {
				isFetching: false,
				networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
				componentData: data,
			} );
		}
    }
    
    /*********************************************/

    /**
     * @desc Render a React view component
     */
    render() {

		const memberId =this.data.memberId
		
        return (
            <ReactivateEpostView
                isFetching={ this.state.isFetching }
                networkStatus={this.state.networkStatus }
				{...get( this.state, 'componentData', {} ) }
                currentStep={ this.state.currentStep }
				requestPayload={ {
                    context: {
                        memberId: memberId,
						patientId: this.data.patientId,
                        journey: 'reactivate',
						reactivationFlowId: this.data.reactivationFlowId,
                    }
				} }
				successView={ this.state.successView }
				onSuccessfullEnrollment={ this.handleSuccessfullEnrollment }
			/>
        );
    }
}

// set display name
_ReactivateEpostWidget.displayName = 'ReactivateEpostWidget';

// set default props
_ReactivateEpostWidget.defaultProps = {};

// prop types
_ReactivateEpostWidget.propTypes = {};


export const ReactivateEpostWidget = withRouter( _ReactivateEpostWidget );
